//combine all slices here as root reducer
import { combineReducers } from 'redux';

const rootReducer = combineReducers({});

export default rootReducer;
